import Skeleton from '../primitives/Skeleton';
import { TableCell, TableRow } from './Table';

export interface TableRowsSkeletonProps {
  /** Number of columns the table renders (used for one cell per column). */
  columns: number;
  /** Number of placeholder rows, ideally matching the page size. */
  rows?: number;
  /**
   * Fixed row height in px, matching the real rows, to avoid vertical layout
   * shift. Needed when real rows are taller than one line of text (e.g. they
   * contain icon buttons or chips). Omit for plain text rows.
   */
  rowHeight?: number;
}

/**
 * Placeholder rows for a table body while data is (re)loading.
 * Render inside <TableBody> so the header and footer stay mounted.
 */
const TableRowsSkeleton = ({ columns, rows = 10, rowHeight }: TableRowsSkeletonProps) => (
  <>
    {Array.from({ length: rows }, (_, row) => (
      <TableRow key={row}>
        {Array.from({ length: columns }, (_, col) => (
          <TableCell key={col} sx={rowHeight ? { height: rowHeight, py: 0 } : undefined}>
            {/* variant="text" reserves the cell's own line-height, so a
                skeleton row is exactly as tall as a one-line text row */}
            <Skeleton variant="text" width={`${50 + ((row + col) % 4) * 12}%`} />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export default TableRowsSkeleton;
